var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"walletArea",attrs:{"dir":"ltr"}},[_c('Factors')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }